import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { DataResponse } from "schema"

type Response = DataResponse<{ handle: string; title: string }[]>

export const shopifyCollectionsQuery = () =>
  queryOptions({
    queryKey: ["shopifyCollections"],
    queryFn: async () => {
      const response = await axios.get<Response>(`/integrations/shopify/collections`)
      return response.data.data
    },
    staleTime: 5 * 60 * 1000,
  })
